import { normalizeGstin, isValidBuyerGstin } from './einvoiceHelpers';

export function formatInvoiceAmount(amount) {
    return Number(amount || 0).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function resolveInvoiceType(invoice) {
    if (invoice?.invoice_type) {
        return invoice.invoice_type;
    }
    if (invoice?.einvoice_irn) {
        return 'B2B';
    }
    if (Number(invoice?.einvoice_status) === 3) {
        return 'B2C';
    }
    const gstNo = normalizeGstin(invoice?.billing_gst_no || invoice?.gst_no || '');
    if (isValidBuyerGstin(gstNo)) {
        return 'B2B';
    }
    return 'B2C';
}

export function buildInvoiceSummaryStats(records = []) {
    let b2bCount = 0;
    let b2cCount = 0;
    let b2bAmount = 0;
    let b2cAmount = 0;
    let totalAmount = 0;
    let totalTaxable = 0;
    let totalTax = 0;
    let einvoiceGenerated = 0;

    records.forEach((invoice) => {
        const amount = Number(invoice.invoice_amt) || 0;
        const taxable = Number(invoice.taxable_amt) || 0;
        const tax = Number(invoice.gst_amt) || 0;
        const invoiceType = resolveInvoiceType(invoice);

        totalAmount += amount;
        totalTaxable += taxable;
        totalTax += tax;

        if (invoice.einvoice_irn) {
            einvoiceGenerated += 1;
        }

        if (invoiceType === 'B2B') {
            b2bCount += 1;
            b2bAmount += amount;
        } else {
            b2cCount += 1;
            b2cAmount += amount;
        }
    });

    return [
        {
            label: 'B2B',
            value: String(b2bCount),
            subValue: formatInvoiceAmount(b2bAmount),
            accent: 'b2b',
        },
        {
            label: 'B2C',
            value: String(b2cCount),
            subValue: formatInvoiceAmount(b2cAmount),
            accent: 'b2c',
        },
        {
            label: 'INVOICE AMOUNT',
            value: formatInvoiceAmount(totalAmount),
        },
        {
            label: 'TAXABLE AMOUNT',
            value: formatInvoiceAmount(totalTaxable),
        },
        {
            label: 'TAX AMOUNT',
            value: formatInvoiceAmount(totalTax),
        },
        {
            label: 'E-INVOICE',
            value: einvoiceGenerated,
            accent: 'yellow',
        },
    ];
}
